import { Card, Box } from '@material-ui/core';
import Icons from 'src/icons';

export const PreviewElement = ({ ext = '', params = {} }) => {
  const isImage =
    ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'webm';
  const isPdf = ext === 'pdf';

  if (isImage) {
    return (
      <Card sx={{ width: '100%', height: '100%', overflow: 'hidden' }}>
        <a href={params?.value} target="_blank" rel="noreferrer noopener">
          <Box
            component="img"
            src={params?.value}
            alt="Preview"
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center',
              display: 'block',
              transition: 'transform 0.2s ease-in-out',
              '&:hover': {
                transform: 'scale(1.05)'
              }
            }}
          />
        </a>
      </Card>
    );
  }
  if (isPdf) {
    return (
      <Card sx={{ 
        width: '100%', 
        height: '100%', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        overflow: 'hidden'
      }}>
        <a 
          href={params?.value} 
          target="_blank" 
          rel="noreferrer noopener"
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            width: '100%',
            height: '100%'
          }}
        >
          <Icons.PictureAsPdfIcon sx={{ 
            width: '60%', 
            height: '60%', 
            maxWidth: '120px',
            maxHeight: '120px',
            minWidth: '40px',
            minHeight: '40px'
          }} />
        </a>
      </Card>
    );
  }
  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      width: '100%',
      height: '100%'
    }}>
      <a 
        href={params?.value} 
        target="_blank" 
        rel="noreferrer noopener"
        style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center'
        }}
      >
        <Icons.InsertDriveFileIcon sx={{ 
          width: '60%', 
          height: '60%', 
          maxWidth: '120px',
          maxHeight: '120px',
          minWidth: '40px',
          minHeight: '40px'
        }} />
      </a>
    </Box>
  );
};
